// utils/authUtils.js

/**
 * Get current logged-in user from Redux profile slice
 * Single source of truth: profile fetched via profileApi.getMyProfile()
 */
export const getCurrentUser = () => {
  const state = window.store?.getState();
  if (!state) return null;

  // Profile slice stores the logged-in employee
  return state.profile?.profile || null;
};

/**
 * Check if user is Super Admin (level_0)
 */
export const isSuperAdmin = (user = getCurrentUser()) => {
  return user?.role_level === "level_0";
};

/**
 * Check if user can manage everything
 * Explicit flag OR level_0
 */
export const canManageEverything = (user = getCurrentUser()) => {
  if (!user) return false;

  return user.can_manage_everything === true || user.role_level === "level_0";
};

export const canManageOrder = (user = getCurrentUser()) => {
  if (!user) return false;

  return user.can_manage_orders === true;
};

/**
 * Full Super Admin
 * Must be level_0 AND can_manage_everything = true
 */
export const isFullSuperAdmin = (user = getCurrentUser()) => {
  if (!user) return false;

  return user.role_level === "level_0" || user.can_manage_everything === true;
};
